import type React from "react";

export function PromoIcon(): React.ReactNode {
  return (
    <svg
      display="block"
      width="27"
      height="27"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Promo</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8416 8.65001L9.34163 1.15001C9.04163 0.850005 8.62496 0.666672 8.16663 0.666672H2.33329C1.41663 0.666672 0.666626 1.41667 0.666626 2.33334V8.16667C0.666626 8.62501 0.849959 9.04167 1.15829 9.35001L8.65829 16.85C8.95829 17.15 9.37496 17.3333 9.83329 17.3333C10.2916 17.3333 10.7083 17.15 11.0083 16.8417L16.8416 11.0083C17.15 10.7083 17.3333 10.2917 17.3333 9.83334C17.3333 9.37501 17.1416 8.95001 16.8416 8.65001ZM3.58329 4.83334C2.89163 4.83334 2.33329 4.27501 2.33329 3.58334C2.33329 2.89167 2.89163 2.33334 3.58329 2.33334C4.27496 2.33334 4.83329 2.89167 4.83329 3.58334C4.83329 4.27501 4.27496 4.83334 3.58329 4.83334ZM9.83329 15.2833L13.3916 11.725C13.7666 11.35 14 10.825 14 10.25C14 9.10001 13.0666 8.16667 11.9166 8.16667C11.3416 8.16667 10.8166 8.40001 10.4416 8.77501L9.83329 9.38334L9.22496 8.78334C8.84996 8.40001 8.32496 8.16667 7.74996 8.16667C6.59996 8.16667 5.66663 9.10001 5.66663 10.25C5.66663 10.825 5.89996 11.3417 6.27496 11.725L9.83329 15.2833Z"
      />
    </svg>
  );
}
